import forge from "node-forge";

/**
 * Decrypts a Base64-encoded encrypted body using AES-CBC with the provided secret key.
 * @param {string} encryptedBody - The Base64-encoded encrypted body (including IV).
 * @param {string} secretKey - The secret key for decryption.
 * @returns {Object} - The decrypted JSON body.
 */
export const decryptBody = (encryptedBody, secretKey) => {
  const shouldDecrypt = process.env.REACT_APP_DECRYPT_RESPONSE === "true";

  if (!secretKey) throw new Error("Secret key is not provided");
  if (!shouldDecrypt) {
    return typeof encryptedBody === "string"
      ? JSON.parse(encryptedBody)
      : encryptedBody;
  }
  // Decode the Base64-encoded encrypted body
  const decodedData = forge.util.decode64(encryptedBody);

  // Extract the IV (first 16 bytes) and the encrypted data (remaining bytes)
  const iv = decodedData.slice(0, 16);
  const encryptedData = decodedData.slice(16);

  // Ensure the secret key is the correct length for AES
  const key = forge.util.createBuffer(secretKey).getBytes(16); // Truncate or pad to 16 bytes

  // Initialize Forge cipher for decryption
  const decipher = forge.cipher.createDecipher("AES-CBC", key);
  decipher.start({ iv: iv });
  decipher.update(forge.util.createBuffer(encryptedData));
  const success = decipher.finish();


  
  if (success) {
    // Return the decrypted data as a JSON object
    const decryptedBody = JSON.parse(decipher.output.toString());
    return decryptedBody;
  } else {
    throw new Error("Decryption failed");
  }
};


